import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['newLink']
  static values = {
    url: String
  }

  declare readonly newLinkTarget: HTMLLinkElement
  declare readonly urlValue: string

  connect (): void {
    const url = new URL(window.location.href)
    const basedOn = url.searchParams.get('based_on') ?? 'standard'
    const paramKey = basedOn === 'policy' ? 'policy_document_id' : 'standard_id'
    const rawValue = url.searchParams.get(paramKey)

    const selectedValue = rawValue !== null ? Number(rawValue) : null

    if (selectedValue !== null && !Number.isNaN(selectedValue) && selectedValue !== 0) {
      this.updateNewUrl(paramKey, selectedValue)
    }
  }

  standardTabChanged (event: Event): void {
    const selectElement = event.target as HTMLSelectElement
    const selectedValue = Number(selectElement.value)

    if (Number.isNaN(selectedValue) || selectedValue === 0) return

    const url = new URL(window.location.href)
    const basedOn = url.searchParams.get('based_on') ?? 'standard'
    const paramKey = basedOn === 'policy' ? 'policy_document_id' : 'standard_id'

    this.updateNewUrl(paramKey, selectedValue)
    this.navigate(paramKey, selectedValue)
  }

  navigate (paramKey: string, selectedValue: number): void {
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set(paramKey, selectedValue.toString())
    Turbo.navigator.history.replace(newUrl)
  }

  private updateNewUrl (paramKey: string, selectedValue: number): void {
    const newUrl = new URL(this.newLinkTarget.href)
    newUrl.searchParams.set(paramKey, selectedValue.toString())
    this.newLinkTarget.setAttribute('href', newUrl.toString())
  }
}
